import {PRODUCTION} from '../constants/actionTypes';
import initial from './initialState';

export default function (state = initial.productionActualYieldState, action) {
  switch (action.type) {
    case PRODUCTION.GET_ACTUAL_YIELD_SUCCESS:
      return {...state, items: action.data.items || [], count: action.data.count || 0};
    default:
      return state;
  }
}
